import React from "react";
import { Alert, Button } from "@mui/material";

const FIELD_LABELS: Record<string, string> = {
  firstName: "First name",
  lastName: "Last name",
  email: "Email",
  phoneNumber: "Phone number",
  dateOfBirth: "Date of birth",
  fileNumber: "File number",
  community: "Community for voucher pickup",
  line1: "Address line 1",
  line2: "Address line 2",
  city: "Community",
  outsideIsrCity: "City/community name",
  postalCode: "Postal code",
  provinceOrTerritory: "Province or territory",
  country: "Country",
  releaseAccept: "Privacy consent",
  memberId: "Family member identifier",
  sameAddressAsApplicant: "Same address as applicant",
  gasStorePreference: "Gas store preference",
  groceryStorePreference: "Grocery store preference",
};
function fieldLabel(path: string): string {
  if (path === "_form") return "Application";
  return path
    .replace(
      /houseHoldMembers\[(\d+)\]/g,
      (_, index) => `Family member ${Number(index) + 1}`,
    )
    .split(".")
    .map(
      (part) =>
        FIELD_LABELS[part] ||
        (
          {
            physicalAddress: "Physical address",
            mailingAddress: "Mailing address",
            houseHoldMembers: "Family members",
            emergencyContact: "Emergency contact",
          } as Record<string, string>
        )[part] ||
        part.replace(/([a-z])([A-Z])/g, "$1 $2"),
    )
    .join(" — ");
}
function focusField(container: HTMLElement | null, path: string): void {
  // Compare names directly: an API path must never become a CSS selector.
  const controls = Array.from(
    container?.querySelectorAll<HTMLElement>(
      "input[name], select[name], textarea[name], button[name]",
    ) || [],
  );
  const target =
    controls.find((control) => control.getAttribute("name") === path) ||
    controls.find(
      (control) =>
        control.getAttribute("name")?.startsWith(`${path}.`) ||
        control.getAttribute("name")?.startsWith(`${path}[`),
    );
  target?.focus();
}

export function OtlSubmissionErrors({
  error,
  fieldErrors,
  fieldsContainer,
}: {
  error: string;
  fieldErrors: Record<string, string[]>;
  fieldsContainer: React.RefObject<HTMLDivElement>;
}) {
  return (
    <Alert severity="error" role="alert">
      {error}
      {Object.keys(fieldErrors).length > 0 && (
        <ul aria-label="Fields to correct">
          {Object.entries(fieldErrors).map(([path, messages]) => (
            <li key={path}>
              {path === "_form" ? (
                `${fieldLabel(path)}: ${messages.join(" ")}`
              ) : (
                <Button
                  type="button"
                  variant="text"
                  color="inherit"
                  sx={{ textTransform: "none", textAlign: "left" }}
                  onClick={() => focusField(fieldsContainer.current, path)}
                >
                  {fieldLabel(path)}: {messages.join(" ")}
                </Button>
              )}
            </li>
          ))}
        </ul>
      )}
    </Alert>
  );
}
